import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createUser, registerBasicInfo, registerLocation } from '../services/users';

export const useCreateUser = () => {
  return useMutation({
    mutationFn: createUser,
    onSuccess: (data) => {
    },
    onError: (error) => {
      console.error('Error creating user:', error);
    },
  });
};

// Step 1: create or look up the person. Resolves to
// { user, alreadyExists } — see services/users.js.
export const useRegisterBasicInfo = () => {
  return useMutation({
    mutationFn: registerBasicInfo,
    onError: (error) => {
      console.error('Error saving basic info:', error);
    },
  });
};

// Step 2: assign the clinical location, role(s) and position, and send the
// welcome email. Refreshes the org user list so the new user shows up.
export const useRegisterLocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: registerLocation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizationUsers'] });
    },
    onError: (error) => {
      console.error('Error assigning location:', error);
    },
  });
};
